<template>
    <div class="infomain">
        <div class="top">
            <div class="left">
                <img src="../../assets/img/znt/infoicon.png" alt="">
                AI智控中...
            </div>
            <div class="right">{{data.time.substr(0, 16)}}更新</div>
        </div>
        <div class="contentbox">
            <div class="cleft">
                <div class="talktip" @click="gotalk">
                    点我对话
                </div>
                <img src="../../assets/img/znt/logo.png" />
            </div>
            <div class="cright">
                <div class="critem">
                    <div class="name">
                        <div class="point"></div>
                        土壤平均湿度
                    </div>
                    <div class="value">
                        {{ data.soil }} %
                    </div>
                </div>
                <div class="critem">
                    <div class="name">
                        <div class="point"></div>
                        空气平均温度
                    </div>
                    <div class="value">
                        {{ data.air }} ℃
                    </div>
                </div>
                <div class="critem">
                    <div class="name">
                        <div class="point"></div>
                        室外气象站瞬时雨量
                    </div>
                    <div class="value">
                        {{ data.rain }} mm
                    </div>
                </div>
            </div>
            <div class="btnbox" @click="gopage">
                <img src="../../assets/img/znt/zkbtn.png" />
            </div>
        </div>
    </div>

</template>

<script >
import {gettempdata} from '@/api/bot'
export default {
    name: 'index',
    components: {},
    data() {
        return {
            data: []
        }
    },
    computed: {

    },
    mounted() {
        this.getdata()
    },
    methods: {
        getdata() {
            gettempdata().then(res => {
                console.log(res)
                this.data = res.data
            })
        },
        gotalk() {
            this.$emit('gotalk')
        },
        gopage() {
            this.$emit('gopage', 1)
        }
        
    }
}




</script>

<style scoped lang="less">
.infomain {
    width: 100%;
    height: 100%;
    position: relative;

    
    .top{
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        .left{
            font-size: 16px;
            display: flex;
            align-items: center;
            color: #1f9c4c;
            img{
                width: 30px;
                margin-right: 10px;
            }
        }
        .right{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 12px;
            color: #00000080;
        }
    }

    .contentbox{
        display: inline-flex;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 20px;
        .cleft{
            width: calc(50% - 0px);
            text-align: cetner;

            .talktip{
                width: 150px;
                height: 60px;
               background-image: url('../../assets/img/znt/talkbg.png'); 
               background-size: 100% 100%;
               display: flex;
               justify-content: center;
               align-items: center;
               font-size: 18px;
               color: #D94D6B;
               cursor: pointer;
            }
            img{
                width: 90%;
            }
        }
        .cright{
            width: calc(50% - 0px);
            background-color: #fff;
            border-radius: 20px;
            padding: 20px 10px;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;

            .critem{
                width: 100%;
                margin-bottom: 20px;
                .name{
                    display: flex;
                    font-size: 14px;
                    color: #00000090;
                    .point{
                        width: 10px;
                        height: 10px;
                        margin-right: 10px;
                        border-radius: 50%;
                        background-color: #e0869a;
                    }
                }
                .value{
                    width: 100%;
                    text-align: center;
                    margin-top: 10px;
                    font-size: 22px;
                    color: #e0869a;
                }
            }
        }
        .btnbox{
            width: 100%;
            text-align: center;
            margin: 50px 0;
            cursor: pointer;
            img{
                height: 50px;
            }
        }
    }
   
}
</style>
